const taxWarrantsHeader = [
  {
    text: 'Tax Year',
    value: 'taxYear',
    align: 'left',
    sortable: false,
  },
  { text: 'Tax ID', value: 'taxId', align: 'left' },
  { text: 'Parcel ID', value: 'propertyOrParcelId', align: 'left' },
  {
    text: 'Warrant#', value: 'warrantNumber', align: 'left',
  },
  { text: 'Alias#', value: 'aliasNumber', align: 'left' },
  {
    text: 'Name',
    value: 'name1',
    formatter: 'combineName',
    combineTextFileds: ['name1', 'name2'],
  },
  {
    text: 'Issue Date', value: 'issueDate', align: 'left', formatter: 'shortDate',
  },
  {
    text: 'Date Served', value: 'servedDate', align: 'left', formatter: 'shortDate',
  },
  {
    text: 'Penalty Date', value: 'penaltyDate', align: 'left', formatter: 'shortDate',
  },
  {
    text: 'Active', value: 'isActive', align: 'left', formatter: 'flagToYorEmpty',
  },

];

const taxWarrantsDetailsHeader = [
  {
    text: 'Tax Year',
    value: 'taxYear',

  },
  {
    text: 'Tax ID', value: 'taxId', align: 'left', sortable: false,
  },
  {
    text: 'Name',
    value: 'name1',
    formatter: 'combineName',
    combineTextFileds: ['name1', 'name2'],
  },
  {
    text: 'Tax Amt', value: 'totalDue', align: 'center', formatter: 'amount', sortable: false,
  },
  {
    text: 'Fees', value: 'totalFee', align: 'center', formatter: 'amount', sortable: false, clickable: true,
  },
  {
    text: 'Penalty', value: 'penaltyAmt', align: 'center', formatter: 'amount', sortable: false,
  },
  {
    text: 'Total Due', value: 'totalDueWithFeesPenalty', align: 'center', formatter: 'amount', sortable: false,
  },
];

export {
  taxWarrantsHeader, taxWarrantsDetailsHeader,
};
